var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "head-nav clear-l"
  }, [_c('div', {
    staticClass: "div"
  }, [_c('div', {
    staticClass: "w1200 bc"
  }, [_c('ul', {
    staticClass: "nav fl"
  }, [_c('li', [_c('a', {
    class: {
      "active": _vm.activeLi === "purchaser"
    },
    attrs: {
      "href": _vm.purchaserUrl
    }
  }, [_vm._v("采购商服务")])]), _vm._v(" "), _c('li', [_c('a', {
    class: {
      "active": _vm.activeLi === "mallIndex"
    },
    on: {
      "click": function($event) {
        _vm.goIndex()
      }
    }
  }, [_vm._v("商城首页")])]), _vm._v(" "), _c('li', [_c('a', {
    class: {
      "active": _vm.activeLi === "brand"
    },
    attrs: {
      "href": _vm.brandUrl
    }
  }, [_vm._v("品牌导航")])]), _vm._v(" "), _c('li', [_c('a', {
    class: {
      "active": _vm.activeLi === "sample"
    },
    on: {
      "click": function($event) {
        _vm.goSample()
      }
    }
  }, [_vm._v("样品中心")])]), _vm._v(" "), _c('li', [_c('a', {
    class: {
      "active": _vm.activeLi === "requirement"
    },
    attrs: {
      "href": _vm.requirementUrl
    }
  }, [_vm._v("需求中心")])]), _vm._v(" "), _c('li', [_c('a', {
    class: {
      "active": _vm.activeLi === "tradingHall"
    },
    attrs: {
      "href": _vm.tradingHallUrl
    }
  }, [_vm._v("交易大厅")])]), _vm._v(" "), _c('li', [_c('a', {
    class: {
      "active": _vm.activeLi === "meterial"
    },
    on: {
      "click": function($event) {
        _vm.goMeterial()
      }
    }
  }, [_vm._v("原材料")])]), _vm._v(" "), _c('li', [_c('a', {
    class: {
      "active": _vm.activeLi === "news"
    },
    attrs: {
      "href": _vm.newsUrl
    }
  }, [_vm._v("新闻百科")])]), _vm._v(" "), _c('li', [_c('a', {
    class: {
      "active": _vm.activeLi === "exhibition"
    },
    attrs: {
      "href": _vm.exhibitionUrl
    }
  }, [_vm._v("展会")])])]), _vm._v(" "), (_vm.firstCatShow) ? _c('div', {
    staticClass: "mall-categorys"
  }, [_c('div', {
    staticClass: "sc-submenu"
  }, [_c('ul', [_vm._m(0), _vm._v(" "), _vm._l((_vm.catList), function(cat, index) {
    return _c('li', {
      class: 'li-' + (index + 1),
      on: {
        "mouseleave": function($event) {
          _vm.childCateHide()
        },
        "mouseenter": function($event) {
          _vm.childCateShow(index)
        }
      }
    }, [_c('div', {
      staticClass: "yj"
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.getMore(cat.catCode, cat.catNameCn)
        }
      }
    }, [_vm._v(_vm._s(cat.catNameCn))])]), _vm._v(" "), _c('div', {
      staticClass: "sc-submenu-all",
      class: {
        "none": _vm.currIndex != index
      },
      style: ('top:' + index * (-45) + 'px'),
      on: {
        "mouseleave": function($event) {
          _vm.childCateHide()
        }
      }
    }, [_c('dl', [_c('dt', [_vm._v(_vm._s(cat.catNameCn))]), _vm._v(" "), _c('dd', [_vm._l((cat.catBoList), function(childCat) {
      return _c('a', {
        on: {
          "click": function($event) {
            _vm.getCatGoods(childCat.catCode, childCat.catNameCn)
          }
        }
      }, [_vm._v(_vm._s(childCat.catNameCn))])
    }), _vm._v(" "), _c('a', {
      on: {
        "click": function($event) {
          _vm.getMore(cat.catCode, cat.catNameCn)
        }
      }
    }, [_vm._v("更多")])], 2)])])])
  })], 2)])]) : _vm._e()])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('div', {
    staticClass: "category-head"
  }, [_vm._v("箱包分类\n            \t\t\t"), _c('div', {
    staticClass: "category-head-border"
  })])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ec01199","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HearderNav.vue
// module id = 1VKG
// module chunks = 1